import { observer } from 'mobx-react-lite';
import ItemTileView, { ItemTileViewPropsBase } from './ItemTileView';
import { Image, ImageFit } from 'office-ui-fabric-react/lib/Image';
import * as React from 'react';

const styles = require('./PhotoTileView.scss');
const classNames = require('classnames');

export interface PhotoTileViewProps extends ItemTileViewPropsBase {
    thumbnailUrl: string;
}

/**
 * As this is only a locally used state which is only required to figure
 * out if the image is loaded hence it is not in the store and limited only
 * within this component so as not to polute global file picker store
 */
export interface PhotoTileViewState {
    isImageLoaded: boolean;
}

export default observer(function PhotoTileView(props: PhotoTileViewProps) {
    const [isImageLoaded, setIsImageLoaded] = React.useState<boolean>(false);
    const onImageLoaded = (event: React.SyntheticEvent<HTMLImageElement>) => {
        setIsImageLoaded(true);
    };
    const isThumbnailAvailable = props.thumbnailUrl ? true : false;
    const photoThumbnailOverlayStyle = props.isSelected
        ? styles.photoThumbnailSelectedOverlay
        : styles.photoThumbnailOverlay;
    return (
        <ItemTileView
            {...(props as any)}
            className={styles.container}
            shouldShowTileOverlay={!isImageLoaded}>
            {!isThumbnailAvailable && (
                <div className={styles.photoIconContainer}>
                    <i
                        className={classNames(props.icon.large, styles.photoIcon)}
                        data-is-focusable={false}
                    />
                </div>
            )}

            {isThumbnailAvailable && (
                <div className={styles.photoThumbnailContainer}>
                    <Image
                        className={styles.photoThumbnail}
                        src={props.thumbnailUrl}
                        onLoad={onImageLoaded}
                        imageFit={ImageFit.cover}
                        data-is-focusable={false}
                    />

                    <div className={photoThumbnailOverlayStyle}>
                        <div className={styles.photoTileOverlay}>
                            <div className={styles.photoTilePrimaryTextOverlay}>
                                {' '}
                                {props.primaryText}{' '}
                            </div>
                            {props.secondaryText && (
                                <div className={styles.photoTileSecondaryTextOverlay}>
                                    {' '}
                                    {props.secondaryText}{' '}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </ItemTileView>
    );
});
